import React from 'react';
import { articles } from '../../data/insights';
import { images } from '../../data/images';
import { ArticleCard } from '../insights/ArticleCard';
import { SectionHeading } from '../ui/SectionHeading';
import { Button } from '../ui/Button';
export function InsightsPreview() {
  const [feature, ...rest] = articles;
  return <section className="bg-ivory py-24 md:py-32" data-id="element-213" data-mp="2vjluppzmweht">
      <div className="container-page" data-id="element-214" data-mp="3j8oi7egy91k8">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end" data-id="element-215" data-mp="3j9pv7ohizy4l">
          <SectionHeading kicker="Insights" title="Perspectives on leadership and talent." data-id="element-216" data-mp="3o6g8y55uyhmu" />
          <Button to="/insights" variant="outline" arrow className="self-start md:self-auto" data-id="element-217" data-mp="39jdanw9po4yg">
            All insights
          </Button>
        </div>
        <div className="mt-12 grid gap-10 lg:grid-cols-12" data-id="element-218" data-mp="3efll4wcyr9za">
          <div className="lg:col-span-7" data-id="element-219" data-mp="60tqzi53m7f9">
            <ArticleCard article={feature} variant="feature" image={images.architecture} data-id="element-220" data-mp="601xccv2ajrm" />
          </div>
          <div className="grid gap-10 lg:col-span-5" data-id="element-221" data-mp="n0ytx7q9bpv">
            {rest.slice(0, 2).map(a => <ArticleCard key={a.slug} article={a} data-id="element-222" data-mp="3rtc64b3bz8pn" />)}
          </div>
        </div>
      </div>
    </section>;
}